import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type { ApiSuccessEnvelope } from "../../types/affiliates";
import { getPrivateInstance } from "../_privateInstance";

export type AffiliateResetPasswordInput = {
  affiliateId: string;
  reason?: string;
};

type AffiliateResetPasswordData = Record<string, unknown>;

const affiliateResetPassword = async ({
  affiliateId,
  reason,
}: AffiliateResetPasswordInput): Promise<{
  data: AffiliateResetPasswordData;
  message: string;
}> => {
  const path = API_ROUTES.AFFILIATE_RESET_PASSWORD.replace(
    "{affiliate_id}",
    encodeURIComponent(affiliateId),
  );
  const response = await getPrivateInstance().post<
    ApiSuccessEnvelope<AffiliateResetPasswordData>
  >(path, reason ? { reason } : {});
  return response.data;
};

export const useAffiliateResetPassword = (): UseMutationResult<
  { data: AffiliateResetPasswordData; message: string },
  Error,
  AffiliateResetPasswordInput
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["affiliates", "reset-password"],
    mutationFn: affiliateResetPassword,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["affiliates", "detail", variables.affiliateId],
      });
      queryClient.invalidateQueries({ queryKey: ["affiliates", "list"] });
    },
  });
};

export { affiliateResetPassword };
